import { Link, } from "react-router-dom";
import "./Login.css";
import { useState, useContext } from 'react';
import { Box, Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, TextField } from "@mui/material";
//import { validarEmail } from "global/utils/validators";
//import { IconVisibility, IconVisibilityOff } from "@aws-amplify/ui-react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CircularProgress from '@mui/material/CircularProgress'; 
//import { UserContext } from 'UserContext';
import { useNavigate, useLocation } from "react-router-dom";
//import { AuthContext } from "global/context/authContextDefinition";
import { useAuth } from 'global/context/AuthProviderV2';


import { Amplify } from 'aws-amplify';
import awsconfig from 'aws-config';
import { validarEmail } from "global/util/validators";

//Amplify.configure(awsconfig);


export const Login = () => {
	//const authContext = useContext(AuthContext);
	const { login  } = useAuth();
	const location = useLocation();
	const from = (location.state as any)?.from?.pathname || "/";
	//console.log("from:"+from);
	
	//const { signIn } = authContext;

	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [loginError, setLoginError] = useState('');
	const [firstTry, setFirstTry] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const [loading, setLoading] = useState(false);


	const handleLogin = async () => {
		setLoading(true)
		try {
			const log = await login( email, password );
			if (log == 'DONE') {
				// Guardamos la sesión en localStorage
				const sessionData = {
					email: email,
					isLoggedIn: true,
				};
				//localStorage.setItem("userSession", JSON.stringify(sessionData));
				navigate(from, { replace: true });
				setLoginError('');
				
			} else if (log == 'CONFIRM_SIGN_IN_WITH_PASSWORD') {
				navigate(`/cambiarpassword`);
			} else if (log == 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
				navigate(`/confirmarpassword?user=${email}`);
			} else if (log == 'BAD_CREDENTIALS') {
				setLoginError('Usuario y Contraseña incorrectos');
			} else {
				setLoginError('');
				console.log('opcion no controlada\n' + JSON.stringify(log));
			}
			console.log(JSON.stringify(log));
		} catch (error) {
			console.error("Ha ocurrido un error: ", JSON.stringify(error));
			setLoginError(processCognitoError(error));
		}
		setLoading(false)
	};

	const processCognitoError = (error: any): string => {
		switch (error?.code) {
			case 'NotAuthorizedException':
				return 'Credenciales inválidas. Por favor, verifica tu correo electrónico y contraseña.';
			case 'UserNotFoundException':
				return 'No se encontró un usuario con esa dirección de correo electrónico.';
			case 'PasswordResetRequiredException':
				return 'Debes restablecer tu contraseña antes de iniciar sesión.';
			case 'UserNotConfirmedException':
				return 'Debes confirmar tu registro antes de poder iniciar sesión. Revisa tu correo electrónico para más detalles.';
			case 'InvalidParameterException':
				return 'Ha ocurrido un error en los parámetros proporcionados.';
			case 'CodeDeliveryFailureException':
				return 'Ha habido un problema al enviar el código de confirmación. Por favor, intenta nuevamente más tarde.';
			case 'TooManyRequestsException':
				return 'Has excedido el límite de intentos. Por favor, espera un momento antes de intentar nuevamente.';
			case 'ExpiredCodeException':
				return 'El código de confirmación ha expirado. Por favor, solicita uno nuevo.';
			default:
				return 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.';
		}
	};

	return (
		<>
			<Box
				className="home-component"
				sx={{ width: 400, marginTop: 3, marginBottom: 5 }}
			>
				<div className="login-container">
					<h2>Iniciar sesión</h2>
					<TextField error={firstTry && !validarEmail(email)} onBlur={() => setFirstTry(true)} fullWidth sx={{ mt: 1, mb: 1 }} id="outlined-basic" label="Correo electrónico" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
					<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
						<InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
						<OutlinedInput
							id="outlined-adornment-password"
							type={showPassword ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
										edge="end"
									>
										{showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
									</IconButton>
								</InputAdornment>
							}
							label="Contraseña"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
					</FormControl>
					{
						loginError === '' ?
							<></> :
							<p style={{ color: "red" }}>*{loginError}</p>
					}

					<Stack spacing={1} direction="row" justifyContent="center" marginTop={2}>
						<Button className="app-primary-button" variant="contained" onClick={handleLogin}>
						{loading ? <CircularProgress size={24} color="inherit" /> : "Iniciar sesión"}
						</Button>
					</Stack>
					<br></br>
					<FormControl>
						¿No tienes usuario? <Link to={`/registro`}>Reg&iacute;strate aqu&iacute;</Link>
					</FormControl>
					<FormControl>
						¿No recuerdas tu contraseña? <Link to={`/recuperar`}>Recup&eacute;rala aqu&iacute;
						</Link>
					</FormControl>

				</div>
			</Box>
		</>
	);
};
